import { toast } from "react-toastify";

const blank_task = ()=> toast('Kuchh karna nhi hai kya🙄?', {
    toastId:"kuchh karna nhi hai",
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    });

const blank_task_eng = ()=> toast('😏don\'t you wanna do anything!', {
    toastId:"don't you wanna do anything",
    position: "top-center",
    autoClose: 5000,
    delay:3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    });

const tempNavAlert = ()=>toast.info('Navbar is Useless...😅Added just for fun😁!', {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    })
export {blank_task, blank_task_eng, tempNavAlert};